module.exports = __webpack_public_path__ + "static/media/21.c50c9cb2.png";